import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
// import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

// core components

function CardInfoBg({
  subtitle,
  title,
  color,
  rightAction,
  bottomAction,
  progressValue,
  progressColor,
}) {
  const theme = useTheme();
  const cardSx = {
    defaultCard: {
      background:
        "linear-gradient(87deg," +
        theme.palette.dark.main +
        ",#1a174d)!important",
    },
    errorCard: {
      background:
        "linear-gradient(87deg," +
        theme.palette.error.main +
        ",#f56036)!important",
    },
    successCard: {
      background:
        "linear-gradient(87deg," +
        theme.palette.success.main +
        ",#2dcecc)!important",
    },
    primaryCard: {
      background:
        "linear-gradient(87deg," +
        theme.palette.primary.main +
        ",#825ee4)!important",
    },
    infoCard: {
      background:
        "linear-gradient(87deg," +
        theme.palette.info.main +
        ",#1171ef)!important",
    },
    warningCard: {
      background:
        "linear-gradient(87deg," +
        theme.palette.warning.main +
        ",#fbb140)!important",
    },
  };
  const progressSx = {
    primaryProgress: {
      backgroundColor: theme.palette.primary.main,
    },
    infoProgress: {
      backgroundColor: theme.palette.info.main,
    },
    errorProgress: {
      backgroundColor: theme.palette.error.main,
    },
    warningProgress: {
      backgroundColor: theme.palette.warning.main,
    },
    defaultProgress: {
      backgroundColor: theme.palette.dark.main,
    },
    successProgress: {
      backgroundColor: theme.palette.success.main,
    },
  };
  return (
    <>
      <Card sx={cardSx[color + "Card"]} elevation={0}>
        <CardContent>
          <Grid container>
            <Grid
              item
              component={Box}
              sx={{ flexBasis: "0", flexGrow: "1", maxWidth: "100%" }}
            >
              <Typography
                variant="h5"
                component="h5"
                sx={{
                  color: theme.palette.white.main,
                  textTransform: "uppercase",
                  marginBottom: 0,
                }}
              >
                {subtitle}
              </Typography>
              <Typography
                variant="h2"
                component="span"
                sx={{ color: theme.palette.white.main, marginBottom: 0 }}
              >
                {title}
              </Typography>
              <Box sx={{ marginTop: "1rem" }}>
                <LinearProgress
                  variant="determinate"
                  value={progressValue}
                  sx={{
                    height: "3px!important",
                    marginBottom: "0",
                    "& .MuiLinearProgress-bar":
                      progressSx[progressColor + "Progress"],
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs="auto">
              {rightAction}
            </Grid>
          </Grid>
          <Box
            component="p"
            sx={{
              fontSize: ".875rem",
              marginBottom: "0",
              marginTop: "1rem",
              lineHeight: "1.7",
              fontWeight: "300",
            }}
          >
            {bottomAction}
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

CardInfoBg.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "error",
    "warning",
    "default",
    "success",
  ]),
  rightAction: PropTypes.node,
  bottomAction: PropTypes.node,
  progressValue: PropTypes.number,
  progressColor: PropTypes.oneOf([
    "primary",
    "info",
    "error",
    "warning",
    "default",
    "success",
  ]),
};

export default CardInfoBg;
